import { Printer } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { PrintFeeDefaultsCard } from "@/modules/cf-feed/presentation/ui/PrintFeeDefaultsCard";

export function PrintFeeSettingsPage() {
  return (
    <>
      <Header />
      <Main>
        <div className="mb-6">
          <div className="inline-flex items-center gap-2">
            <Printer className="size-5 text-muted-foreground" aria-hidden />
            <h1 className="font-bold text-xl tracking-tight">ຄ່າພິມຊື່ / ໝາຍເລກ</h1>
          </div>
          <p className="mt-1 max-w-2xl text-muted-foreground text-sm">
            ຕັ້ງຄ່າເລີ່ມຕົ້ນ NAME_PRINT ແລະ NUMBER_PRINT ສຳລັບລະບົບ CF. ຄ່າເກັບໃນ Admin
            ແລະໃຊ້ເມື່ອເປີດຕົວເລືອກພິມໃນໂພສ / Live.
          </p>
        </div>

        <div className="max-w-2xl">
          <PrintFeeDefaultsCard />
        </div>
      </Main>
    </>
  );
}
